<form class="register-form" [formGroup]="BirthDay">
  <div class="row m-0">
    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-2 p-0">
      <mat-form-field class="example-full-width my-form-field"  [appearance]="appearance" fillColor="accent">
        <mat-label>{{'SCHEDULE.DAY'|translate}}</mat-label>
        <mat-select formControlName="day" required>
          <mat-option [value]="item" *ngFor="let item of days">
            {{item}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="BirthDay.get('day').hasError('required')">
          {{'REQUIRED'|translate}} {{'DAY'|translate}}
        </mat-error>
      </mat-form-field>
    </div>
    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-2 p-0">
      <mat-form-field class="example-full-width my-form-field"  [appearance]="appearance" fillColor="accent">
        <mat-label>{{'SCHEDULE.MONTH'|translate}}</mat-label>
        <mat-select formControlName="month" required (keyup)="keyMonthEvent($event)">
          <mat-option [value]="item.id" *ngFor="let item of months">
            {{item.name | translate }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="BirthDay.get('day').hasError('required')">
          {{'REQUIRED'|translate}} {{'DAY'|translate}}
        </mat-error>
      </mat-form-field>
    </div>
    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-2 p-0">
      <mat-form-field class="example-full-width my-form-field"  [appearance]="appearance"   fillColor="accent">
        <mat-label>{{'SCHEDULE.YEAR'|translate}}</mat-label>
        <mat-select formControlName="year" required>
          <mat-option [value]="item" *ngFor="let item of years">
            {{item}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="BirthDay.get('day').hasError('required')">
          {{'REQUIRED'|translate}} {{'DAY'|translate}}
        </mat-error>
      </mat-form-field>
    </div>
  </div>
</form>